export default __webpack_public_path__ + "static/PROUD_lg-90442cbd090d3524738b6ad32bcfe90a.webp";